import { render, staticRenderFns } from "./UpdateMerchantBusinessAddressModal.vue?vue&type=template&id=473c1c9f&scoped=true&"
import script from "./UpdateMerchantBusinessAddressModal.vue?vue&type=script&lang=js&"
export * from "./UpdateMerchantBusinessAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMerchantBusinessAddressModal.vue?vue&type=style&index=0&id=473c1c9f&scoped=true&lang=css&"
import style1 from "./UpdateMerchantBusinessAddressModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c1c9f",
  null
  
)

export default component.exports